import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('routes.mail.index'),
        name: i18n.t('routes.mail.index'),
        component: () =>
            import(/* webpackChunkName: "mails" */ '@/views/mails/Index.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.tc('resources.mail.name', 2),
                    to: { name: i18n.t('routes.mail.index') },
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/' + i18n.t('routes.mail.edit') + '/:id',
        name: i18n.t('routes.mail.edit'),
        component: () =>
            import(/* webpackChunkName: "mails" */ '@/views/mails/Edit.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.tc('resources.mail.name', 2),
                    to: { name: i18n.t('routes.mail.index') },
                    disable: false,
                },
                {
                    text: i18n.t('resources.default.edit'),
                    to: { name: i18n.t('routes.mail.edit') },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
